<a type="button" class="btn btn-default" (click)="readBarodeClick(true)">{{'Read OK'| translate }}</a>
<a type="button" class="btn btn-default" (click)="readBarodeClick(false)">{{'Read NOK'| translate }}</a>
<a type="button" class="btn btn-default" (click)="enteredClick(true)">{{'Entered'| translate }}</a>
<a type="button" class="btn btn-default" (click)="enteredClick(false)">{{'Not entered'| translate }}</a>

